A short phrase intended for display to a user that describes the advertisement product.
